import { HStack, Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

type PublicationTypesProps = {
  publicationTypes?: Array<string>;
};
const PublicationTypes = ({ publicationTypes }: PublicationTypesProps) => {
  const { t } = useTranslation();
  return publicationTypes ? (
    <HStack spacing={2}>
      {publicationTypes.map((type) => (
        <Tag key={type} backgroundColor={"brand.400"}>
          {t(`search.filters.publicationTypes.${type.replaceAll(" ", "")}`)}
        </Tag>
      ))}
    </HStack>
  ) : null;
};

export default PublicationTypes;
